
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
data() {
return {







}
},
props: {
list: {
type: Array,
default:()=>{
return []
}
},
},
components: {
Tab,
TabItem
},
methods: {
handler(index,item) {
if(item.statistic){
item.statistic()
}
this.$emit("tabClick",index)
},
},
}
